import { RollPositionTag } from "@/pages/catalogs/shared/components/RollPositionTag";
import { rollPositionCodes } from "@/shared/selectors/RollPositionSelector";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { RollOperation } from "../../../models/Operation";

type Props = {};
export const useTableData = ({}: Props) => {
	const columnDefs: ColDef[] = [
		// Visible
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Sections",
			headerName: "Section",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Stands",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "RollPosition",
			headerName: "Position",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				rollPositionCodes.find(
					(code) => code.Code === (params.data as RollOperation).RollPosition,
				)?.Name,
			cellRenderer: RollPositionTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				position: rollPositionCodes.find(
					(code) => code.Code === (params.data as RollOperation).RollPosition,
				),
			}),
		},
		{
			field: "Diameter",
			headerName: "Diameter",
			minWidth: 20,
			flex: 1,
		},
	];
	return { columnDefs };
};
